<template>
  <div>
    <div id="vz-gh20"></div>
  </div>
</template>

<script>
export default {
  name: "vpsHeader",
  components: {},
  data() {
    return {
      componentName: "/",
    };
  },
  beforeMount() {
    // eslint-disable-next-line no-undef
    gnavdl = {
      bu: "smb",
      appid: "vpslimited",
    };
  },
  mounted() {
    var header = document.createElement("script");
    header.setAttribute(
      "src",
      "https://www.verizon.com/etc/designs/vzwcom/gnav20/smb.js"
    );
    header.setAttribute("async", "async");
    document.head.appendChild(header);
    this.componentName = this.$route.name;
  },
};
</script>
<style scoped>
</style>
